const Loader = (props)=>{
    return (
        <div className="loader js-loader" role="status">
        <div className="loader__item"></div>
    </div>
    )
}
export default Loader